(function () {
    let index = 0;
    let i = setInterval(() => {
        const button = document.querySelector('.restock-rocket-button-container-float-right');
        const target = document.querySelector('.product__info-wrapper .product-parameters');
        if (button) {
            button.style.position = 'relative';
            button.style.top = 'auto';
            button.style.marginTop = '1.6rem';
            button.style.transform = 'none';
            target.appendChild(button);
            button.style.display = 'block';
            button.style.fontSize = 'calc(var(--font-button-scale) * 1rem)';
            // button.style.padding = '1rem';
            clearInterval(i);
        }
        index++;
        if (index === 1000) {
            clearInterval(i);
        }
    }, 100);
})();